/* eslint-disable no-underscore-dangle */
import React, { useMemo } from "react";
import { Form, Collapse, Select } from "antd";
import { APP_LIST } from "../../../../views/Users/utils/utils";

const { Panel } = Collapse;
const { Option } = Select;

const APP_NAMES = APP_LIST.map((item) => item.app_name);

const SSOSelection = ({
  setFieldsValue,
  applicationData = [],
  applicationPermissionIndexes = [],
  applicationRolesList = [],
}) => {
  const getAppRolesOptions = (app_id) => {
    const getAppList = applicationData.find((item) => item._id === app_id);
    const processedOptionList = applicationRolesList.filter(
      (text) => text.app_id === getAppList._id,
    );

    return processedOptionList.map((item) => {
      return {
        _id: item._id,
        role_name: item.role_name,
      };
    });
  };

  const appsList = useMemo(() => {
    const appRoles = [];
    const relevantApps = applicationData?.filter((app) =>
      APP_NAMES.includes(app.app_name),
    );

    const apps = relevantApps.map((app) => {
      const relevantAppRoles = applicationRolesList?.filter(
        (appRole) => appRole.app_id === app._id,
      );
      const allocatedAppRole = relevantAppRoles.find((AppRole) =>
        applicationPermissionIndexes?.includes(AppRole._id),
      );
      appRoles.push(allocatedAppRole?._id || null);

      return {
        appName: app.app_name,
        application_role_id: allocatedAppRole?._id ?? null,
        app_id: app._id,
      };
    });
    setFieldsValue({
      app_roles: appRoles,
    });
    return apps;
  }, [applicationData, applicationRolesList, applicationPermissionIndexes]);

  return (
    <div>
      {appsList.map((item, index) => {
        return (
          <Collapse defaultActiveKey={item.appName} expandIconPosition="end">
            <Panel header={item.appName} key={item.appName}>
              <Form.Item
                label={
                  item.appName === "IntelliSight Plus"
                    ? "User Role"
                    : "Solution Access"
                }
                name={[`app_roles`, index]}
              >
                <Select
                  placeholder={`${item.appName} Solution Access`}
                  showSearch
                  style={{ width: "15%" }}
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {getAppRolesOptions(item.app_id).map((option) => {
                    return (
                      <Option key={option?._id} value={option?._id}>
                        {option?.role_name}
                      </Option>
                    );
                  })}
                  <Option value={null}>No</Option>
                </Select>
              </Form.Item>
            </Panel>
          </Collapse>
        );
      })}
    </div>
  );
};

export default SSOSelection;
